import { inject, injectable } from 'inversify'
import symbols from '../../symbols'
import {
  AddMemberInvitationUseCaseInput,
  AddMemberInvitationUseCaseOutput,
  IAddMemberInvitationUseCase,
  IAppErrorFactory,
  IInvitationsService,
} from '../../types'

@injectable()
export default class AddMemberInvitationInteractor implements IAddMemberInvitationUseCase {
  @inject(symbols.IInvitationsService) private invitationsService: IInvitationsService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  async handle(input: AddMemberInvitationUseCaseInput): Promise<AddMemberInvitationUseCaseOutput> {
    const output = this.getDefaultOutputData()
    try {
      output.invitationLink = await this.invitationsService.addMemberInvitation(input)
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
      })
    }

    return output
  }

  private getDefaultOutputData(): AddMemberInvitationUseCaseOutput {
    return {
      invitationLink: null,
      error: null,
    }
  }
}
